import { AxiosError } from 'axios';
import { eventsRequest } from '../../utils/eventsRequest';
import { ErrorResponse } from '../../types';
import { formatDobForApi } from '../../utils';

export interface UpdateChildPayload {
  fname?: string;
  lname?: string;
  dob?: string;
}

export interface UpdateChildResult {
  success: boolean;
  message: string;
}

const updateChild = async (
  childId: number,
  payload: UpdateChildPayload
): Promise<UpdateChildResult> => {
  const result: UpdateChildResult = {
    success: false,
    message: 'Failed to update child.',
  };

  try {
    const normalizedPayload = {
      ...payload,
      ...(payload.dob !== undefined ? { dob: formatDobForApi(payload.dob) } : {}),
    };

    const response = await eventsRequest<{
      statusCode: number;
      isSuccess: boolean;
      data: any;
    }>(`/children/${childId}`, 'patch', normalizedPayload);

    if (response.status === 200 && response.data?.isSuccess) {
      result.success = true;
      result.message = 'Child updated.';
    }

    return result;
  } catch (error) {
    const axiosError = error as AxiosError<ErrorResponse>;
    if (axiosError.response?.data?.message) {
      result.message = axiosError.response.data.message;
    }
    return result;
  }
};

export default updateChild;

